import { AuthApiService } from '@marpla/api-sdk';

import { createHttpAgent } from './session-api';
import { getSessionManager } from '../session';

let authApiService: AuthApiService | undefined;

export function getAuthApiService(): AuthApiService {
  return (authApiService ??= new AuthApiService(createHttpAgent(), getSessionManager()));
}
